import * as React from "react";
import * as ReactDOM from "react-dom";
import Purchase from "./purchase/Purchase";
import MyProfile from "./profile/MyProfile";
import PublicInvoice from "./Invoice/PublicInvoice";

function PurchasePage (props) {
   return (<>
   <Purchase />
   </>);
 }

 function ProfilePage (props) {
  return (<>
  <MyProfile />
  </>);
}

function InvoicePage (props) {
  return (<>
  <PublicInvoice />
  </>);
}

document.addEventListener( 'DOMContentLoaded', function() {
  var element = document.getElementById( 'devsaccounting-checkout' );
  if( typeof element !== 'undefined' && element !== null ) {
      ReactDOM.createRoot(document.getElementById("devsaccounting-checkout")).render(
         <React.StrictMode>
             <PurchasePage/>
         </React.StrictMode>
     );
  }
} )

document.addEventListener( 'DOMContentLoaded', function() {
  var element = document.getElementById( 'devsaccounting-myprofile' );
  if( typeof element !== 'undefined' && element !== null ) {
      ReactDOM.createRoot(document.getElementById("devsaccounting-myprofile")).render(
        <React.StrictMode>
            <ProfilePage/>
        </React.StrictMode>
    );
  }
} )

document.addEventListener( 'DOMContentLoaded', function() {
  var element = document.getElementById( 'devsaccounting-publicInvoice' );
  if( typeof element !== 'undefined' && element !== null ) {
      ReactDOM.createRoot(document.getElementById("devsaccounting-publicInvoice")).render(
        <React.StrictMode>
            <InvoicePage/>
        </React.StrictMode>
    );
  }
} )
